import { IconLock } from "@tabler/icons-react";
import { Fragment, useCallback } from "react";

import { Notification } from "../../../utils/Notification";
import AuthorizationModal from "../../_Modals/AuthorizationModal/AuthorizationModal";
import { useSaveEntry } from "../../hooks/useSaveEntry";
import { PendingFilesProvider } from "../../LogBar/PendingFilesContext";
import RowActionButton from "../RowActionButton/RowActionButton";
import { crumb } from "../../../utils";

const InlineSaveButton = () => {
  const { saveEntry, loading, opened, open, close, usersSelect, disabled } =
    useSaveEntry();

  const handleOpen = useCallback(async () => {
    // Log inline save button click
    crumb("Inline Save Button: Clicked", {
      component: "InlineSaveButton",
      disabled,
    });

    try {
      await open();
    } catch (error) {
      crumb("Inline Save Button: Open modal failed", {
        error: String(error),
      });
      Notification("Error", String(error), "red");
      console.log(error);
    }
  }, [open, disabled]);

  return (
    <Fragment>
      <RowActionButton
        icon={<IconLock />}
        onClick={handleOpen}
        color="red"
        disabled={disabled}>
        Save
      </RowActionButton>
      <AuthorizationModal
        opened={opened}
        close={close}
        onSubmit={saveEntry}
        loading={loading}
        users={usersSelect}
        isEntry={true}
      />
    </Fragment>
  );
};

const InlineSaveButtonProvider = () => {
  return (
    <PendingFilesProvider>
      <InlineSaveButton />
    </PendingFilesProvider>
  );
};

export default InlineSaveButtonProvider;
